import React from "react";
import { Sparkles, ChevronDown, ChevronUp, Zap } from "lucide-react";

interface ProspectiveCandidatesBannerProps {
  collapsed: boolean;
  onToggleCollapse: () => void;
  candidateCount: number;
}

export const ProspectiveCandidatesBanner: React.FC<ProspectiveCandidatesBannerProps> = ({
  collapsed,
  onToggleCollapse,
  candidateCount
}) => {
  return (
    <div
      onClick={onToggleCollapse}
      style={{
        background: "#ffffff",
        border: "1px solid rgba(99,102,241,0.18)",
        borderLeft: "4px solid #6366f1",
        borderRadius: "12px",
        marginBottom: "20px",
        padding: "14px 18px",
        display: "flex",
        alignItems: "center",
        gap: "16px",
        cursor: "pointer",
        boxShadow: "0 1px 6px rgba(99,102,241,0.07)",
        transition: "box-shadow 0.2s",
      }}
    >
      {/* AI icon bubble */}
      <div style={{
        flexShrink: 0,
        width: "38px", height: "38px",
        borderRadius: "10px",
        background: "linear-gradient(135deg, #6366f1 0%, #818cf8 100%)",
        display: "flex", alignItems: "center", justifyContent: "center",
        boxShadow: "0 2px 8px rgba(99,102,241,0.30)",
      }}>
        <Sparkles size={18} color="#fff" />
      </div>

      {/* Text block */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
          <span style={{ fontWeight: 700, fontSize: "0.92rem", color: "#1e293b" }}>
            Prospective Candidates
          </span>

          {/* Count badge */}
          <div style={{
            display: "flex", alignItems: "center", gap: "5px",
            background: "rgba(99,102,241,0.09)",
            border: "1px solid rgba(99,102,241,0.22)",
            borderRadius: "20px",
            padding: "3px 10px 3px 7px",
          }}>
            <Zap size={11} color="#6366f1" fill="#6366f1" />
            <span style={{ fontSize: "0.75rem", fontWeight: 700, color: "#4f46e5" }}>
              {candidateCount} AI match{candidateCount !== 1 ? "es" : ""} found
            </span>
          </div>

          <span style={{
            fontSize: "0.72rem", color: "#94a3b8",
            fontWeight: 500, letterSpacing: "0.3px",
          }}>
            via AI Talent Match
          </span>
        </div>

        <p style={{
          margin: "4px 0 0 0",
          fontSize: "0.78rem",
          color: "#64748b",
          lineHeight: 1.5,
        }}>
          Our internal database identified candidates with matching skillsets — staged in the Prospective lane below.
        </p>
      </div>

      {/* Collapse toggle */}
      <button
        style={{
          flexShrink: 0,
          background: "rgba(99,102,241,0.07)",
          border: "1px solid rgba(99,102,241,0.18)",
          borderRadius: "8px",
          cursor: "pointer",
          color: "#6366f1",
          display: "flex", alignItems: "center", justifyContent: "center",
          width: "30px", height: "30px",
          transition: "background 0.15s",
        }}
        onClick={(e) => { e.stopPropagation(); onToggleCollapse(); }}
      >
        {collapsed ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
      </button>
    </div>
  );
};
